import { indigo } from '@material-ui/core/colors'

export const colors = {
  backgroundBlue: indigo[50],
  white: '#FFF',
}
